<template>
  <v-container id="login">
    <v-row class="hidden-md-and-up" justify="center">
      <v-slide-y-transition appear>
        <v-card
          class="card-resposive pa-0 ma-0 px-0 pt-6"
          style="width: 80%; padding: 0 10% 0 5%"
        >
          <v-img
            height="10%"
            contain
            src="../../../../assets/logo-imprimax.svg"
          ></v-img>
          <v-card-text class="pa-6 text-center">
            <div
              style="display: flex; justify-content: flex-start"
              class="benvenuto pb-3"
            >
              <span style="font-size: 2.3rem; padding: 5% 0 7% 5%"
                >Bem Vindo!</span
              >
            </div>

            <v-form
              style="padding: 0 10% 0 5%"
              class="py-2"
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                tabindex="1"
                outlined
                class="btn-login"
                v-model="email"
                :rules="emailRules"
                @keydown.enter="login"
                label="Login..."
                required
              />

              <v-text-field
                outlined
                tabindex="2"
                class="btn-login"
                v-model="password"
                :rules="passwordRules"
                @keydown.enter="login"
                color="secondary"
                type="password"
                label="Senha..."
                required
                style="padding: 0"
              />

              <p
                class="router-link right"
                style="
                  display: flex;
                  justify-content: flex-end;
                  padding: 0 0 0 5%;
                "
              >
                <router-link
                  style="
                    padding: 0 0 0 5%;
                    text-decoration: none;
                    color: #bc0000;
                  "
                  to="forgotpassword"
                  >Esqueci minha senha</router-link
                >
              </p>
            </v-form>

            <div style="padding: 0 10% 10% 9%">
              <v-btn
                block
                @click="login"
                :loading="loading"
                class="btns-login"
                color="#BC0000"
              >
                <p style="color: white; margin-bottom: 0px">Login</p>
              </v-btn>

              <!-- <v-btn
                @click="$router.push('/register')"
                :loading="loading"
                :disabled="!valid"
                large
                color="blue-grey lighten-3"
                class="v-btn--text success--text"
              >
                <p style="color: white; margin-bottom: 0px">Registrar</p>
              </v-btn> -->
            </div>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-row>
    <v-row class="hidden-sm-and-down" justify="center">
      <v-slide-y-transition appear>
        <v-card
          class="card-resposive pa-0 ma-0 px-0 pt-6"
          style="width: 40%; padding: 0 10% 0 5%"
        >
          <v-img
            height="30px"
            contain
            src="../../../../assets/logo-imprimax.svg"
          ></v-img>
          <v-card-text class="pa-6 text-center">
            <div
              style="display: flex; justify-content: flex-start"
              class="benvenuto pb-3"
            >
              <span style="font-size: 3rem; padding: 5% 0 7% 12%"
                >Bem Vindo!</span
              >
            </div>

            <v-form
              style="padding: 0 10% 0 5%"
              class="py-2"
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                tabindex="1"
                outlined
                class="btn-login"
                v-model="email"
                :rules="emailRules"
                @keydown.enter="login"
                label="Login..."
                prepend-icon="mdi-email"
                required
              />

              <v-text-field
                outlined
                tabindex="2"
                class="btn-login"
                v-model="password"
                :rules="passwordRules"
                @keydown.enter="login"
                color="secondary"
                type="password"
                label="Senha..."
                prepend-icon="mdi-lock-outline"
                required
                style="padding: 0"
              />

              <p
                class="router-link right"
                style="
                  display: flex;
                  justify-content: flex-end;
                  padding: 0 0 0 5%;
                "
              >
                <router-link
                  style="
                    padding: 0 0 0 5%;
                    text-decoration: none;
                    color: #bc0000;
                  "
                  to="forgotpassword"
                  >Esqueci minha senha</router-link
                >
              </p>
            </v-form>

            <div style="padding: 0 10% 10% 9%">
              <v-btn
                block
                @click="login"
                :loading="loading"
                class="btns-login"
                color="#BC0000"
              >
                <p style="color: white; margin-bottom: 0px">Login</p>
              </v-btn>

              <!-- <v-btn
                @click="$router.push('/register')"
                :loading="loading"
                :disabled="!valid"
                large
                color="blue-grey lighten-3"
                class="v-btn--text success--text"
              >
                <p style="color: white; margin-bottom: 0px">Registrar</p>
              </v-btn> -->
            </div>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";

export default {
  name: "Login",

  components: {
    // PagesBtn: () => import('./components/Btn'),
  },

  data: () => ({
    loading: false,
    error: false,
    valid: true,
    email: "",
    emailRules: [
      (v) =>
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          v
        ) || "E-mail inválido.",
    ],

    password: "",
    passwordRules: [(v) => !!v || "Senha requerida"],
    apiService: new ApiService(),
    socials: [
      {
        href: "#",
        icon: "mdi-facebook-box",
      },
      {
        href: "#",
        icon: "mdi-twitter",
      },
      {
        href: "#",
        icon: "mdi-github-box",
      },
    ],
  }),

  methods: {
    validate() {
      return this.$refs.form.validate();
    },

    async login() {
      if (this.validate()) {
        this.error = null;
        var self = this;
        this.loading = true;
        const user = {
          Email: this.email,
          Password: this.password,
        };
        var client = new ApiService();

        await client
          .post("user/token", user)
          .then((result) => {
            localStorage.setItem("modalOrders", true);
            if (result.user.status != 0 || result.user.type == 3) {
              const user = JSON.stringify(result.user);
              this.$store.commit("SET_LOGGED_USER", user);
              this.$store.commit("SET_CURRENT_TOKEN", result.token);
              this.$store.commit("SET_EXPIRES_TOKEN", result.validTo);
              this.$refs.form.reset();
              this.loading = false;
              if (result.user.type == 8) {
                this.$router.push("/installers");
              } else if (result.user.type == 2) {
                this.$router.push("/dash-resale");
              } else if (result.user.type == 3) {
                this.$router.push("/installers-service");
              } else this.$router.push("/dashboard");
            } else {
              localStorage.removeItem("token");
              localStorage.removeItem("user");
              self.$refs.form.reset();

              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "warning",
                title: "Usuário Inativo",
                message: "Login ainda não ativo pela IMPRIMAX",
                trace: null,
              });

              self.loading = false;
            }
          })
          .catch((erro) => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            //self.$refs.form.reset();

            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não Autorizado",
              message: erro.body.message,
              trace: null,
            });

            self.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.router-link {
  font-size: 85%;
}

.btns-login {
  display: flex;
  color: #bc0000;
  justify-content: space-around;
  width: 85%;
  margin: auto;
}

.router-link:hover {
  font-size: 14px;
  color: #4e94ec;
  text-decoration: underline;
}

.benvenuto {
  font-family: Roboto;
  font-size: 140%;
  color: #2d3038;
}

.right {
  text-align: -webkit-right;
}

.btn-login {
  box-sizing: border-box;
  border-radius: 10px;
}

@media (max-width: 600px) {
  /* .card-resposive {
    width: 60%;
    margin: auto;

  } */
}
</style>
